import { render, staticRenderFns } from "./Phones.vue?vue&type=template&id=0177deb7&"
import script from "./Phones.vue?vue&type=script&lang=js&"
export * from "./Phones.vue?vue&type=script&lang=js&"
import style0 from "./Phones.vue?vue&type=style&index=0&id=0177deb7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports